import {productConfig} from './productConfig';
import {websiteApiBase} from './websiteApiBase';
export const SITE = {
  name: "Orrbbit",
  tagline: "Real People. Real Moments. Right Nearby.",
  supportEmail: "support@orrbbit.com",
  url: process.env.REACT_APP_PUBLIC_SITE_URL || "https://www.orrbbit.com",
};

export const API = websiteApiBase(process.env.REACT_APP_APP_API_URL, typeof window === 'undefined' ? '' : window.location.hostname);

export const LOGO = "/brand/orrbbit-logo.png";
export const ICON = "/brand/orrbbit-icon.png";
// Current branch People web captures for review, rendered at 1170×2532. Native acceptance remains pending.
// Missing captures remain null; obsolete assets cannot pass PhoneMockup's current-capture guard.
export const APP_SHOTS = {radar:'/brand/current-people-radar-141.png',today:null,profile:'/brand/current-people-public-profile-141.png',nearby:'/brand/current-people-explore-141.png',discovery:'/brand/current-people-explore-141.png',event:null,encounters:null,connection:null,navigation:null,businessHome:null,businessEvents:null,businessProfile:null};
export const APP_SHOT = APP_SHOTS.radar;
export const APP_SHOT_PRO = APP_SHOTS.radar;
export const APP_SHOT_BIZ = APP_SHOTS.businessHome;

const ALL_NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/how-orrbitt-uses-ai", label: "Matching" },
  { to: "/people", label: "People" },
  { to: "/vibes", label: "Vibes" },
  { to: "/business", label: "Business" },
  { to: "/pricing", label: "Pricing" },
  { to: "/safety", label: "Safety" },
  { to: "/about", label: "About" },
  { to: "/benefits-of-human-connection", label: "Benefits of Human Connection" },
];
export function activeNavigation(){return ALL_NAV.filter(item=>(productConfig.businessEnabled||item.to!=='/business')&&(productConfig.peopleMonetizationEnabled||item.to!=='/pricing'));}

